import React, { useEffect, useState } from 'react';
import { Check, Book, Moon, Heart, Compass, AlertTriangle, Clock, ShieldAlert, EyeOff, FileText, FlaskConical, Leaf } from 'lucide-react';
import { Section, CTAButton } from './Shared';
import { FeatherQuill, MoonPhase } from './HealingIcons';
import { Pricing } from './Pricing';
const LaunchUrgency = () => {
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 8,
    s: 35
  });
  const [spotsTaken, setSpotsTaken] = useState(() => {
    const saved = typeof window !== 'undefined' ? sessionStorage.getItem('saberes-launch-spots') : null;
    if (saved) {
      const {
        value,
        timestamp
      } = JSON.parse(saved);
      const elapsed = (Date.now() - timestamp) / 1000;
      const increment = Math.floor(elapsed / 60);
      return Math.min(value + increment, 92);
    }
    return 62;
  });
  useEffect(() => {
    sessionStorage.setItem('saberes-launch-spots', JSON.stringify({
      value: spotsTaken,
      timestamp: Date.now()
    }));
  }, [spotsTaken]);
  useEffect(() => {
    const id = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) s--;else {
          s = 59;
          if (m > 0) m--;else {
            m = 59;
            if (h > 0) h--;
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(id);
  }, []);
  useEffect(() => {
    const id = setInterval(() => {
      setSpotsTaken(prev => {
        if (prev >= 92) return prev;
        return Math.random() < 0.4 ? prev + 1 : prev;
      });
    }, 45000 + Math.random() * 30000);
    return () => clearInterval(id);
  }, []);
  const fmt = (n: number) => n.toString().padStart(2, '0');
  const TimeBox = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-245">
      <div className="bg-brand-purple text-white font-mono font-bold text-2xl md:text-4xl rounded-xl px-3 md:px-5 py-2 md:py-3 min-w-[56px] md:min-w-[80px] text-center shadow-md tabular-nums border border-brand-purpleLight/40" data-id="element-246">
        {fmt(value)}
      </div>
      <span className="text-[10px] md:text-xs font-medium text-brand-text/70 mt-1.5 uppercase tracking-wider" data-id="element-247">
        {label}
      </span>
    </div>;
  return <div className="max-w-4xl mx-auto mb-12" data-id="element-248">
      <div className="glass-panel rounded-3xl p-6 md:p-8 border-2 border-brand-purple/40 bg-gradient-to-br from-white/95 to-brand-purpleLight/10 shadow-[0_10px_40px_rgba(45,95,63,0.12)]" data-id="element-249">
        <div className="flex items-center justify-center gap-2 mb-5" data-id="element-250">
          <Clock className="w-5 h-5 md:w-6 md:h-6 text-brand-purple shrink-0" data-id="element-251" />
          <h3 className="font-serif font-bold text-base md:text-xl text-brand-purpleDark text-center" data-id="element-252">
            ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
          </h3>
        </div>

        <div className="flex items-center justify-center gap-2 md:gap-4 mb-5" data-id="element-253">
          <TimeBox value={timeLeft.h} label="Horas" data-id="element-254" />
          <span className="text-2xl md:text-4xl font-bold text-brand-purple/60 pb-5" data-id="element-255">
            :
          </span>
          <TimeBox value={timeLeft.m} label="Min" data-id="element-256" />
          <span className="text-2xl md:text-4xl font-bold text-brand-purple/60 pb-5" data-id="element-257">
            :
          </span>
          <TimeBox value={timeLeft.s} label="Seg" data-id="element-258" />
        </div>

        <div className="flex items-center justify-center gap-2 bg-amber-50 border border-amber-300/60 rounded-xl px-4 py-3 mb-6" data-id="element-259">
          <AlertTriangle className="w-4 h-4 md:w-5 md:h-5 text-amber-600 shrink-0" data-id="element-260" />
          <p className="text-sm md:text-base font-semibold text-amber-900 text-center" data-id="element-261">
            Después sube $8.000 ARS.{' '}
            <span className="text-brand-purple" data-id="element-262">No vuelve.</span>
          </p>
        </div>

        <div className="bg-white/80 rounded-2xl p-4 md:p-5 border border-brand-purple/30" data-id="element-263">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 mb-3" data-id="element-264">
            <div className="flex items-center gap-2" data-id="element-265">
              <span className="relative flex h-2.5 w-2.5" data-id="element-266">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-brand-burgundy opacity-75" data-id="element-267"></span>
                <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-brand-burgundy" data-id="element-268"></span>
              </span>
              <span className="font-semibold text-sm md:text-base text-brand-text" data-id="element-269">
                Cupos al precio de lanzamiento
              </span>
            </div>
            <span className="text-xs md:text-sm font-bold text-brand-purple uppercase tracking-wide" data-id="element-270">
              Quedan pocos
            </span>
          </div>

          <div className="w-full bg-brand-purple/15 rounded-full h-2.5 overflow-hidden mb-2" data-id="element-271">
            <div className="bg-gradient-to-r from-brand-purple to-brand-purpleDark h-2.5 rounded-full transition-all duration-1000 ease-out" style={{
            width: `${spotsTaken}%`
          }} data-id="element-272" />
          </div>

          <p className="text-xs md:text-sm text-brand-text/70 text-center" data-id="element-273">
            <strong className="text-brand-purple" data-id="element-274">{spotsTaken}%</strong> de los
            cupos al precio de lanzamiento ya tomados
          </p>
        </div>
      </div>
    </div>;
};
const tomo1Features = ['✅ Nombre científico y popular', '✅ Principios activos y acción farmacológica', '✅ Indicaciones terapéuticas por nivel de evidencia', '✅ Dosificación profesional por preparación', '✅ Contraindicaciones y poblaciones de riesgo', '✅ Semáforo de seguridad 🟢🟡🔴', '✅ Referencias científicas verificables'];
const tomo2Features = ['✅ Fundamentos de extracción vegetal', '✅ Selección de solventes según principio activo', '✅ Infusiones y decocciones con temperaturas exactas', '✅ Tinturas madre y alcoholaturas paso a paso', '✅ Oleatos en frío y en caliente', '✅ Pomadas, ungüentos y cremas', '✅ Jarabes, elixires y arropes medicinales', '✅ Control de calidad artesanal', '✅ Conservación, envasado y vida útil', '✅ Buenas Prácticas de Elaboración (BPE)', '✅ Etiquetado profesional obligatorio'];
const tomo3Features = ['✅ Tabla maestra de interacciones planta-fármaco', '✅ Dosificación en embarazo y lactancia', '✅ Protocolo ante reacciones adversas', '✅ Señales de alarma clínica', '✅ Checklist del terapeuta antes de prescribir'];
const protocolos = [{
  sys: '🌿 Digestivo',
  cond: 'Gastritis, SII, Hepatitis crónica'
}, {
  sys: '🫁 Respiratorio',
  cond: 'Resfrío, Gripe, Asma, Bronquitis'
}, {
  sys: '🧠 Nervioso',
  cond: 'Ansiedad, Insomnio, Depresión leve'
}, {
  sys: '❤️ Cardiovascular',
  cond: 'Hipertensión, Várices, Colesterol'
}, {
  sys: '⚖️ Endocrino',
  cond: 'Diabetes tipo 2, Menopausia, Tiroides'
}, {
  sys: '🦴 Osteoarticular',
  cond: 'Artritis, Artrosis, Osteoporosis'
}];
const bonuses = [{
  icon: FileText,
  title: 'FICHAS DE CONSULTORIO: GESTIÓN DE PACIENTES',
  pages: '30 páginas · listo para imprimir',
  color: 'text-brand-purple',
  bgColor: 'bg-brand-purple/10',
  borderColor: 'border-brand-purple/30',
  desc: 'Sistema completo de registro clínico para terapeutas de salud natural. Desde la primera consulta hasta el alta terapéutica.',
  result: '✅ Registro clínico profesional desde el primer paciente',
  price: '$12.000'
}, {
  icon: FlaskConical,
  title: 'RECETARIO MAESTRO: 48 FÓRMULAS MAGISTRALES',
  pages: '45 páginas · listo para imprimir',
  color: 'text-brand-goldDark',
  bgColor: 'bg-brand-gold/10',
  borderColor: 'border-brand-gold/30',
  desc: '48 fórmulas concretas y listas para usar organizadas por objetivo terapéutico. Infusiones, extractos y pomadas.',
  result: '✅ Respuesta concreta para cada cuadro',
  price: '$15.000'
}, {
  icon: Leaf,
  title: 'GUÍA DE PROVEEDORES Y COSECHA ÉTICA',
  pages: '30 páginas · listo para imprimir',
  color: 'text-brand-purpleLight',
  bgColor: 'bg-brand-purpleLight/10',
  borderColor: 'border-brand-purpleLight/30',
  desc: 'Todo lo que necesitás saber para conseguir materia prima de calidad, evaluarla correctamente y cosechar con conciencia terapéutica.',
  result: '✅ Materia prima de calidad asegurada',
  price: '$10.000'
}];
const planComparison = [{
  situation: 'Querés preparaciones de mayor potencia terapéutica',
  without: 'Solo tinturas y extractos clásicos',
  with: 'Elixires espagíricos con triple extracción'
}, {
  situation: 'Tu paciente quiere integrar las hierbas en su alimentación',
  without: 'No tenés cómo orientarlo',
  with: 'Recetario completo de fitococina terapéutica'
}, {
  situation: 'Querés diferenciarte de otros terapeutas',
  without: 'Usás los mismos recursos que todos',
  with: 'Dominás un nivel que pocos terapeutas conocen'
}, {
  situation: 'Tu paciente no tolera las tinturas alcohólicas',
  without: 'Sin alternativa concentrada',
  with: 'Elixires y preparaciones especiales disponibles'
}, {
  situation: 'Querés expandir tus servicios y cobrar más',
  without: 'Limitado a preparaciones básicas',
  with: 'Preparaciones de alta gama con respaldo técnico'
}, {
  situation: 'Un paciente te pide algo más profundo',
  without: 'No sabés qué ofrecerle',
  with: 'Protocolo espagírico listo para presentar'
}];
export const MethodOverview = () => {
  return <Section id="method" className="relative" data-id="element-275">
      {/* Decorative elements */}
      <FeatherQuill className="hidden lg:block absolute top-20 right-[3%] w-8 h-8 opacity-25 animate-float-soft" color="#2D5F3F" style={{
      transform: 'rotate(-15deg)'
    }} data-id="element-276" />
      <MoonPhase className="hidden lg:block absolute top-60 left-[2%] w-10 h-10 opacity-30 animate-float-soft" color="#6B9A7A" style={{
      transform: 'rotate(12deg)',
      animationDelay: '1.5s'
    }} data-id="element-277" />

      <div className="text-center mb-12" data-id="element-278">
        <div className="inline-flex items-center space-x-2 bg-white border border-brand-purple/40 px-4 py-1.5 rounded-full mb-6 shadow-sm" data-id="element-279">
          <span className="text-xl" data-id="element-280">🏆</span>
          <span className="font-serif font-semibold tracking-wider text-brand-purple text-sm md:text-base" data-id="element-281">
            KIT SABERES ANCESTRALES ARGENTINOS™
          </span>
        </div>
        <h2 className="text-2xl md:text-5xl font-display font-bold mb-4 leading-tight text-brand-purpleDark" data-id="element-282">
          3 Tomos Principales + 3 Bonus Estratégicos
        </h2>
        <p className="text-brand-text/70 text-base md:text-lg" data-id="element-283">
          335 páginas — Todo resuelto.
        </p>
      </div>

      <div className="max-w-5xl mx-auto mb-12 space-y-6" data-id="element-284">
        {/* Tomo I */}
        <div className="rounded-2xl p-6 md:p-8 border bg-brand-purple/5 border-brand-purple/25 backdrop-blur-sm shadow-sm" data-id="element-285">
          <div className="flex flex-col md:flex-row md:items-start gap-4 md:gap-6" data-id="element-286">
            <div className="shrink-0 mx-auto md:mx-0 w-32 md:w-40" data-id="element-287">
              <div className="w-full aspect-[3/4] bg-brand-purple rounded-md shadow-lg ring-1 ring-brand-purple/15 flex items-center justify-center p-4 text-center border-l-4 border-brand-gold" data-id="element-288">
                <h4 className="font-serif font-bold text-brand-goldLight text-sm md:text-base leading-tight" data-id="element-289">
                  TOMO I<br data-id="element-290" />
                  <span className="text-xs font-normal" data-id="element-291">ENCICLOPEDIA A-Z</span>
                </h4>
              </div>
            </div>
            <div className="flex-grow" data-id="element-292">
              <h4 className="font-serif font-bold mb-2 text-lg text-brand-purpleDark" data-id="element-293">
                TOMO I — ENCICLOPEDIA A-Z DE FLORA NATIVA ARGENTINA
              </h4>
              <p className="text-brand-text/90 font-medium mb-2 text-base" data-id="element-294">
                60 fichas técnicas · validación CONICET, ANMAT, INTA, Farmacopea
                Argentina
              </p>
              <p className="text-brand-text text-sm mb-4" data-id="element-295">
                La primera enciclopedia clínica de plantas medicinales
                argentinas creada para el terapeuta profesional. Desde Ambay
                hasta Zarzaparrilla, cada planta documentada con respaldo
                científico real.
              </p>

              <div className="bg-white/80 p-4 rounded-lg border border-brand-purple/15 mb-4" data-id="element-296">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-3 gap-y-1.5 text-xs md:text-sm text-brand-text" data-id="element-297">
                  {tomo1Features.map((f, i) => <div key={i} className="flex items-center" data-id="element-298">
                      <span data-id="element-299">{f}</span>
                    </div>)}
                </div>
              </div>
              <p className="text-brand-text text-sm mb-4" data-id="element-300">
                Plantas como Carqueja, Lapacho, Peperina, Cedrón, Chañar, Yerba
                Mate, Llantén y Boldo Nativo — todas con respaldo científico.
              </p>
              <p className="font-serif italic text-brand-purple text-sm" data-id="element-301">
                Dejá de buscar información dispersa en internet. Tenés todo lo
                que necesitás en un solo lugar, organizado y validado.
              </p>
            </div>
          </div>
        </div>

        {/* Tomo II */}
        <div className="rounded-2xl p-6 md:p-8 border bg-brand-amber/5 border-brand-amber/25 backdrop-blur-sm shadow-sm" data-id="element-302">
          <div className="flex flex-col md:flex-row md:items-start gap-4 md:gap-6" data-id="element-303">
            <div className="shrink-0 mx-auto md:mx-0 w-32 md:w-40" data-id="element-304">
              <div className="w-full aspect-[3/4] bg-brand-amber rounded-md shadow-lg ring-1 ring-brand-amber/15 flex items-center justify-center p-4 text-center border-l-4 border-brand-purpleDark" data-id="element-305">
                <h4 className="font-serif font-bold text-white text-sm md:text-base leading-tight" data-id="element-306">
                  TOMO II
                  <br data-id="element-307" />
                  <span className="text-xs font-normal" data-id="element-308">PREPARACIONES</span>
                </h4>
              </div>
            </div>
            <div className="flex-grow" data-id="element-309">
              <h4 className="font-serif font-bold mb-2 text-lg text-brand-amber" data-id="element-310">
                TOMO II — TRATADO DE PREPARACIONES Y EXTRACCIÓN
              </h4>
              <p className="text-brand-text/90 font-medium mb-2 text-base" data-id="element-311">
                60 páginas · manual técnico
              </p>
              <p className="text-brand-text text-sm mb-4" data-id="element-312">
                El manual técnico que transforma tu conocimiento herbolario en
                preparaciones profesionales y seguras. Parámetros exactos para
                cada método de extracción.
              </p>

              <div className="bg-white/80 p-4 rounded-lg border border-brand-amber/15 mb-4" data-id="element-313">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-3 gap-y-1.5 text-xs md:text-sm text-brand-text" data-id="element-314">
                  {tomo2Features.map((f, i) => <div key={i} className="flex items-center" data-id="element-315">
                      <span data-id="element-316">{f}</span>
                    </div>)}
                </div>
              </div>
              <p className="font-serif italic text-brand-amber text-sm" data-id="element-317">
                Porque no alcanza con saber qué planta usar — también tenés que
                saber cómo prepararla correctamente para que funcione.
              </p>
            </div>
          </div>
        </div>

        {/* Tomo III */}
        <div className="rounded-2xl p-6 md:p-8 border bg-brand-greenMoss/5 border-brand-greenMoss/25 backdrop-blur-sm shadow-sm" data-id="element-318">
          <div className="flex flex-col md:flex-row md:items-start gap-4 md:gap-6" data-id="element-319">
            <div className="shrink-0 mx-auto md:mx-0 w-32 md:w-40" data-id="element-320">
              <div className="w-full aspect-[3/4] bg-brand-greenMoss rounded-md shadow-lg ring-1 ring-brand-greenMoss/15 flex items-center justify-center p-4 text-center border-l-4 border-brand-gold" data-id="element-321">
                <h4 className="font-serif font-bold text-white text-sm md:text-base leading-tight" data-id="element-322">
                  TOMO III
                  <br data-id="element-323" />
                  <span className="text-xs font-normal" data-id="element-324">CLÍNICA</span>
                </h4>
              </div>
            </div>
            <div className="flex-grow" data-id="element-325">
              <h4 className="font-serif font-bold mb-2 text-lg text-brand-greenMoss" data-id="element-326">
                TOMO III — CLÍNICA DE LA HERBORISTERÍA NATIVA
              </h4>
              <p className="text-brand-text/90 font-medium mb-2 text-base" data-id="element-327">
                60 páginas · El volumen más poderoso del kit
              </p>
              <p className="text-brand-text text-sm mb-4" data-id="element-328">
                Protocolos terapéuticos listos para aplicar en tu consultorio
                desde el primer día. Criterio clínico puro: protocolos por
                sistema, dosificación adaptada por población y tabla maestra de
                interacciones medicamentosas.
              </p>

              <div className="bg-white/80 p-4 rounded-lg border border-brand-greenMoss/15 mb-4" data-id="element-329">
                <p className="text-xs font-bold uppercase tracking-wider text-brand-greenMoss mb-3" data-id="element-330">
                  Protocolos terapéuticos incluidos
                </p>
                <div className="space-y-2 mb-4" data-id="element-331">
                  {protocolos.map((p, i) => <div key={i} className="flex flex-col sm:flex-row sm:items-center text-xs md:text-sm border-b border-brand-greenMoss/10 pb-1 last:border-0 last:pb-0" data-id="element-332">
                      <span className="font-medium w-40 shrink-0 text-brand-text" data-id="element-333">
                        {p.sys}
                      </span>
                      <span className="text-brand-text/80" data-id="element-334">{p.cond}</span>
                    </div>)}
                </div>
                <p className="text-xs md:text-sm text-brand-text mb-4 italic" data-id="element-335">
                  Cada protocolo incluye fórmula magistral lista para usar,
                  dosificación adulto/pediátrica/adulto mayor, duración del
                  tratamiento y criterios de derivación médica.
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-3 gap-y-1.5 text-xs md:text-sm text-brand-text" data-id="element-336">
                  {tomo3Features.map((f, i) => <div key={i} className="flex items-center" data-id="element-337">
                      <span data-id="element-338">{f}</span>
                    </div>)}
                </div>
              </div>
              <p className="font-serif italic text-brand-greenMoss text-sm" data-id="element-339">
                Este tomo es la diferencia entre un terapeuta que "conoce
                plantas" y uno que trata pacientes con criterio clínico real.
              </p>
            </div>
          </div>
        </div>

        <div className="text-center mb-8 mt-12" data-id="element-340">
          <h3 className="text-xl md:text-2xl font-serif font-bold text-brand-purpleDark" data-id="element-341">
            🎁 3 BONUS ESTRATÉGICOS
          </h3>
          <p className="text-xs md:text-sm uppercase tracking-wider text-brand-goldDark mt-1 font-bold" data-id="element-342">
            SIEMPRE INCLUIDOS
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-343">
          {bonuses.map((bonus, i) => {
          const Icon = bonus.icon;
          const numberLabel = String(i + 1).padStart(2, '0');
          return <div key={i} className="glass-panel rounded-2xl p-5 border-brand-purple/30 relative overflow-hidden bg-white/90 flex flex-col" data-id="element-344">
                <div className={`absolute top-3 left-3 ${bonus.bgColor} border ${bonus.borderColor} ${bonus.color} text-[11px] font-mono font-bold px-2 py-0.5 rounded-md`} data-id="element-345">
                  {numberLabel}
                </div>
                <div className="absolute top-0 right-0 bg-brand-gold text-brand-purpleDark text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-346">
                  GRATIS
                </div>

                <div className={`w-20 h-28 mt-6 mb-4 rounded shadow-md border-l-2 border-white/20 flex items-center justify-center p-2 text-center ${bonus.bgColor.replace('/10', '')} ring-1 ring-black/5`} data-id="element-347">
                  <span className="font-serif font-bold text-[10px] leading-tight text-white drop-shadow-md" data-id="element-348">
                    {bonus.title}
                  </span>
                </div>

                <h4 className="text-base font-serif font-bold mb-2 leading-tight text-brand-text" data-id="element-349">
                  {bonus.title}
                </h4>
                <p className={`${bonus.color} text-xs font-medium mb-3`} data-id="element-350">
                  {bonus.pages}
                </p>
                <p className="text-brand-text mb-3 text-xs flex-grow" data-id="element-351">
                  {bonus.desc}
                </p>
                <div className="text-xs font-medium text-brand-purple mb-2" data-id="element-352">
                  {bonus.result}
                </div>
                <div className="text-xs text-brand-text/50 mt-auto" data-id="element-353">
                  <span className="line-through" data-id="element-354">{bonus.price}</span>
                  <span className="ml-2 font-bold text-brand-goldDark" data-id="element-355">
                    → GRATIS
                  </span>
                </div>
              </div>;
        })}
        </div>

        <div className="text-center mt-8" data-id="element-356">
          <div className="inline-block glass-panel px-6 py-3 rounded-full border-brand-purple/30 bg-white/80" data-id="element-357">
            <p className="text-sm md:text-base font-medium text-brand-text" data-id="element-358">
              Valor total bonos{' '}
              <span className="line-through text-brand-text/50" data-id="element-359">$37.000</span>{' '}
              <span className="text-brand-purple font-bold" data-id="element-360">
                → GRATIS con tu Kit Saberes Ancestrales Argentinos
              </span>
            </p>
          </div>
        </div>
      </div>

      <LaunchUrgency data-id="element-361" />

      <Pricing data-id="element-362" />

      {/* Alquimia Nativa — comparison */}
      <div className="max-w-4xl mx-auto mb-12 mt-12" data-id="element-363">
        <div className="bg-white rounded-2xl p-5 md:p-6 border border-brand-purple/30 shadow-sm" data-id="element-364">
          <p className="text-base md:text-lg font-semibold text-brand-purpleDark mb-4 text-center" data-id="element-365">
            🎓 ¿Qué agrega el Módulo Elite ALQUIMIA NATIVA?
          </p>

          <div className="hidden md:block" data-id="element-366">
            <div className="grid grid-cols-3 gap-2 text-[11px] font-semibold uppercase tracking-wide text-brand-text/60 border-b border-brand-purple/20 pb-2 mb-2" data-id="element-367">
              <div data-id="element-368">Situación</div>
              <div className="text-brand-burgundy" data-id="element-369">❌ Sin Alquimia Nativa</div>
              <div className="text-brand-purple" data-id="element-370">✅ Con Alquimia Nativa</div>
            </div>
            <div className="space-y-2" data-id="element-371">
              {planComparison.map((row, i) => <div key={i} className="grid grid-cols-3 gap-2 text-xs text-brand-text py-1.5 border-b border-brand-purple/10 last:border-0" data-id="element-372">
                  <div className="font-medium" data-id="element-373">{row.situation}</div>
                  <div className="text-brand-burgundy/80" data-id="element-374">{row.without}</div>
                  <div className="text-brand-purple font-medium" data-id="element-375">
                    {row.with}
                  </div>
                </div>)}
            </div>
          </div>

          <div className="md:hidden space-y-3" data-id="element-376">
            {planComparison.map((row, i) => <div key={i} className="border-b border-brand-purple/15 pb-3 last:border-0 last:pb-0" data-id="element-377">
                <p className="text-xs font-semibold text-brand-text mb-1.5" data-id="element-378">
                  {row.situation}
                </p>
                <div className="text-[11px] text-brand-burgundy/80 mb-0.5" data-id="element-379">
                  ❌ {row.without}
                </div>
                <div className="text-[11px] text-brand-purple font-medium" data-id="element-380">
                  ✅ {row.with}
                </div>
              </div>)}
          </div>

          <p className="text-sm font-medium text-brand-goldDark italic text-center mt-5" data-id="element-381">
            Un solo paciente de nivel avanzado ya paga la diferencia de precio.
          </p>
        </div>
      </div>
    </Section>;
};